import { Logger } from "../../helpers/Logger";
import { getTrackingId } from "../config/CONSTANTS";

/**
 * Tracks an event and sends data to TikTok Pixel.
 */
export function trackTiktokPixelEvent(eventType, eventData) {
  if (typeof window.ttq === "undefined" || typeof window.ttq.track !== "function") {
    (function (w, d, t) {
      w.TiktokAnalyticsObject = t;
      var ttq = (w[t] = w[t] || []);
      ttq.methods = [
        "page",
        "track",
        "identify",
        "instances",
        "debug",
        "on",
        "off",
        "once",
        "ready",
        "alias",
        "group",
        "enableCookie",
        "disableCookie",
      ];
      ttq.setAndDefer = function (obj, method) {
        obj[method] = function () {
          obj.push([method].concat(Array.prototype.slice.call(arguments, 0)));
        };
      };
      for (var i = 0; i < ttq.methods.length; i++) {
        ttq.setAndDefer(ttq, ttq.methods[i]);
      }
      ttq.instance = function (instanceId) {
        var instance = ttq._i[instanceId] || [];
        for (var j = 0; j < ttq.methods.length; j++) {
          ttq.setAndDefer(instance, ttq.methods[j]);
        }
        return instance;
      };
      ttq.load = function (pixelId, options) {
        var url = `https://analytics.tiktok.com/i18n/pixel/events.js?sdkid=${pixelId}&lib=${t}`;
        ttq._i = ttq._i || {};
        ttq._i[pixelId] = [];
        ttq._t = ttq._t || {};
        ttq._t[pixelId] = +new Date();
        ttq._o = ttq._o || {};
        ttq._o[pixelId] = options || {};
        var script = d.createElement("script");
        script.type = "text/javascript";
        script.async = true;
        script.src = url;
        script.onerror = () => Logger.error("Failed to load TikTok Pixel script");
        script.onload = () => {
          Logger.log("TikTok Pixel script loaded successfully");
          ttq.loaded = true;
        };
        var firstScript = d.getElementsByTagName("script")[0];
        firstScript.parentNode.insertBefore(script, firstScript);
      };

      ttq.load(getTrackingId("Tiktok_Pixel"));
    })(window, document, "ttq");
  }

  // Ensure ttq is available before tracking
  if (window.ttq && typeof window.ttq.track === "function") {
    window.ttq.track(eventType, eventData);
    Logger.log(`TikTok Pixel event sent: ${eventType}`, eventData);
  } else {
    Logger.warn(`TikTok Pixel not initialized yet, event skipped: ${eventType}`);
  }
}
